import type { CSSProperties, RefObject } from "react";

interface AnimationsLottieBoxProps {
  /** The element lottie-web renders its SVG into. */
  containerRef: RefObject<HTMLDivElement | null>;
  /** Constrain the rendered width/height (px). Unset means the animation's own size. */
  width?: number | undefined;
  height?: number | undefined;
}

/**
 * Break glass: the box a Lottie animation is mounted into. lottie-web needs a
 * real element to draw into, and callers size it with pixel numbers they compute
 * (a spinner scales its animation to twice its container, then clips it), so the
 * width and height are runtime values rather than design tokens.
 */
export function AnimationsLottieBox({
  containerRef,
  width,
  height,
}: AnimationsLottieBoxProps) {
  const box: CSSProperties = {
    ...(width !== undefined && { width }),
    ...(height !== undefined && { height }),
  };

  return <div style={box} ref={containerRef} data-testid="lottie-box" />;
}
